<form [formGroup]="form">
  <div class="card-content">
    <div>
      <div class="full-width">
        <h4>Lote</h4>
        <mat-divider></mat-divider>
          <mat-form-field class="medium-width margin-right-small">
            <input type="text" matInput placeholder="Nombre" formControlName="Name" required>
            <mat-error *ngIf="f.Name.errors && f.Name.errors.required">
              Ingrese el nombre
            </mat-error>
          </mat-form-field>
          <mat-form-field class="medium-width margin-right-small">
            <input type="text" matInput placeholder="Descripción" formControlName="Description">
          </mat-form-field>
          <mat-form-field class="medium-width margin-right-small">
            <input type="text" matInput placeholder="Sector origen" formControlName="SectorSend" required [matAutocomplete]="autSectorSend">
            <mat-autocomplete #autSectorSend="matAutocomplete" [displayWith]="filterCompleteSectorSend.displayFn">
              <mat-option *ngFor="let sectorFilter of filteredSectorSendOptions | async" [value]="sectorFilter">
                {{sectorFilter.Name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="f.SectorSend.errors && f.SectorSend.errors.required">
              Seleccione un sector origen
            </mat-error>
          </mat-form-field>
          <mat-form-field class="medium-width margin-right-small">
            <input type="text" #sectorReceiver matInput placeholder="Sector destino" formControlName="SectorReceiver" required [matAutocomplete]="autSectorReceiver">
            <mat-autocomplete #autSectorReceiver="matAutocomplete" [displayWith]="filterCompleteSectorReceiver.displayFn">
              <mat-option *ngFor="let sectorFilter of filteredSectorReceiverOptions | async" [value]="sectorFilter">
                {{sectorFilter.Name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="f.SectorReceiver.errors && f.SectorReceiver.errors.required">
              Seleccione un sector origen
            </mat-error>
          </mat-form-field>
          <mat-form-field class="medium-width margin-right-small">
            <input matInput autocomplete="off" formControlName="ReceptionDate" [matDatepicker]="pickerFrom" placeholder="Fecha recepción" required>
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
            <mat-error *ngIf="f.ReceptionDate.errors && f.ReceptionDate.errors.required">
              Ingrese la fecha de recepción
            </mat-error>
          </mat-form-field>
      </div>
    </div>
  </div>
</form>
